document.addEventListener('DOMContentLoaded', function() {
    // Configurações do carrossel
    const carouselContainer = document.querySelector('.carousel-container');
    const carouselTrack = document.querySelector('.carousel-track');
    const slides = document.querySelectorAll('.carousel-slide');
    
    if (!carouselTrack || slides.length === 0) return;
    
    // Configurações
    let slidesToShow = 3; // Valor padrão para desktop
    const animationDuration = 40; // duração total da animação em segundos
    
    // Função para determinar número de slides baseado no tamanho da tela
    function getSlidesToShow() {
        return window.innerWidth <= 768 ? 1.5 : 3;
    }
    
    // Inicializar slidesToShow com base no tamanho atual da janela
    slidesToShow = getSlidesToShow();
    
    // Função para criar um carrossel infinito
    function setupInfiniteCarousel() {
        // Clonar os slides para criar o efeito infinito
        const slidesArray = Array.from(slides);
        
        // Criar clones dos slides originais
        slidesArray.forEach(slide => {
            const clone = slide.cloneNode(true);
            carouselTrack.appendChild(clone);
        });
        
        // Calcular larguras responsivamente
        function calculateDimensions() {
            // Atualizar o número de slides com base no tamanho atual da janela
            slidesToShow = getSlidesToShow();
            
            const containerWidth = carouselContainer.offsetWidth;
            const slideWidth = containerWidth / slidesToShow;
            
            // Aplicar largura a todos os slides (originais e clones)
            const allSlides = carouselTrack.querySelectorAll('.carousel-slide');
            allSlides.forEach(slide => {
                slide.style.width = `${slideWidth}px`;
            });
            
            // Definir largura total do track (agora com o dobro de slides)
            carouselTrack.style.width = `${slideWidth * allSlides.length}px`;
            
            // Reiniciar a animação quando as dimensões mudam
            startAnimation(slideWidth, allSlides.length);
        }
        
        // Iniciar animação fluida contínua
        function startAnimation(slideWidth, totalSlides) {
            // Parar qualquer animação anterior
            carouselTrack.style.animation = 'none';
            
            // Forçar reflow para garantir que a animação anterior foi removida
            void carouselTrack.offsetWidth;
            
            // Calcular a distância total para animar (o comprimento de todos os slides originais)
            const animationDistance = slideWidth * (totalSlides / 2);
            
            // Adicionar keyframes dinamicamente para uma animação suave e infinita
            const styleSheet = document.styleSheets[0];
            let keyframeRule = `@keyframes scrollLeft {
                0% { transform: translateX(0); }
                100% { transform: translateX(-${animationDistance}px); }
            }`;
            
            // Remover regra anterior se existir
            for (let i = 0; i < styleSheet.cssRules.length; i++) {
                if (styleSheet.cssRules[i].name === 'scrollLeft') {
                    styleSheet.deleteRule(i);
                    break;
                }
            }
            
            // Adicionar nova regra
            try {
                styleSheet.insertRule(keyframeRule, styleSheet.cssRules.length);
            } catch(e) {
                console.error('Erro ao inserir regra CSS:', e);
            }
            
            // Aplicar a animação ao track
            carouselTrack.style.animation = `scrollLeft ${animationDuration}s linear infinite`;
        }
        
        // Calcular dimensões iniciais
        calculateDimensions();
        
        // Recalcular em caso de redimensionamento
        window.addEventListener('resize', calculateDimensions);
        
        // Controles de pausa/resume ao passar o mouse
        carouselContainer.addEventListener('mouseenter', () => {
            carouselTrack.style.animationPlayState = 'paused';
        });
        
        carouselContainer.addEventListener('mouseleave', () => {
            carouselTrack.style.animationPlayState = 'running';
        });
    }
    
    // Inicialização
    setupInfiniteCarousel();
});
